<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick" style="max-width: 700px;">
  <template #header>
    <div>
      <span>{{isCalendar ? '日历审核' : '数据统计'}}</span>
      <span style="margin-left: 3em;">{{currentSite.name ? currentSite.name : '--'}} -- {{currentSiteDevice ? currentSiteDevice.name : '--'}}</span>
      <el-select v-if="isCalendar" v-model="value" size="small" style="width: 100px;float: right;margin-right: 10px;" @change="dateChange">
        <el-option
          v-for="item in options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>
  </template>

  <template #body>
    <el-table
      :data="dataList"
      style="width: 100%"
      height="100%"
      border
      stripe
      highlight-current-row
      header-row-class-name="custom-table-header"
      class="custom-table no-inner-border"
      v-if="isCalendar"
    >
      <el-table-column prop="mon" label="一" align="center">
        <template slot-scope="{row}">
          <div>
            <h4 style="margin: 2px; text-align:center;">{{row['mon'].dataTime ? new Date(row['mon'].dataTime).format('DD') : ''}}</h4>
            <div style="display: flex;justify-content: space-around;">
              <p
                class="my-button"
                v-for="(el, i) in row['mon'].data"
                :key="i"
                :style="`background: ${el ? (el.status ? '#67C23A' : '#E6A23C') : '#909399'};`"
                :title="el ? el.orgName : '未审核'"
                v-if="i + 1 <= ((Math.log2(auditAuth) | 0) + 1) ? true : false"
                @click="onCakendarItemClick(row['mon'], i)"
              >
                {{el ? numberToCN[i + 1] + '审' : '未审核'}}
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="tue" label="二" align="center">
        <template slot-scope="{row}">
          <div>
            <h4 style="margin: 2px; text-align:center;">{{row['tue'].dataTime ? new Date(row['tue'].dataTime).format('DD') : ''}}</h4>
            <div style="display: flex;justify-content: space-around;">
              <p
                class="my-button"
                v-for="(el, i) in row['tue'].data"
                :key="i"
                :style="`background: ${el ? (el.status ? '#67C23A' : '#E6A23C') : '#909399'};`"
                :title="el ? el.orgName : '未审核'"
                v-if="i + 1 <= ((Math.log2(auditAuth) | 0) + 1) ? true : false"
                @click="onCakendarItemClick(row['tue'], i)"
              >
                {{el ? numberToCN[i + 1] + '审' : '未审核'}}
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="wed" label="三" align="center">
        <template slot-scope="{row}">
          <div>
            <h4 style="margin: 2px; text-align:center;">{{row['wed'].dataTime ? new Date(row['wed'].dataTime).format('DD') : ''}}</h4>
            <div style="display: flex;justify-content: space-around;">
              <p
                class="my-button"
                v-for="(el, i) in row['wed'].data"
                :key="i"
                :style="`background: ${el ? (el.status ? '#67C23A' : '#E6A23C') : '#909399'};`"
                :title="el ? el.orgName : '未审核'"
                v-if="i + 1 <= ((Math.log2(auditAuth) | 0) + 1) ? true : false"
                @click="onCakendarItemClick(row['wed'], i)"
              >
                {{el ? numberToCN[i + 1] + '审' : '未审核'}}
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="thu" label="四" align="center">
        <template slot-scope="{row}">
          <div>
            <h4 style="margin: 2px; text-align:center;">{{row['thu'].dataTime ? new Date(row['thu'].dataTime).format('DD') : ''}}</h4>
            <div style="display: flex;justify-content: space-around;">
              <p
                class="my-button"
                v-for="(el, i) in row['thu'].data"
                :key="i"
                :style="`background: ${el ? (el.status ? '#67C23A' : '#E6A23C') : '#909399'};`"
                :title="el ? el.orgName : '未审核'"
                v-if="i + 1 <= ((Math.log2(auditAuth) | 0) + 1) ? true : false"
                @click="onCakendarItemClick(row['thu'], i)"
              >
                {{el ? numberToCN[i + 1] + '审' : '未审核'}}
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="fri" label="五" align="center">
        <template slot-scope="{row}">
          <div>
            <h4 style="margin: 2px; text-align:center;">{{row['fri'].dataTime ? new Date(row['fri'].dataTime).format('DD') : ''}}</h4>
            <div style="display: flex;justify-content: space-around;">
              <p
                class="my-button"
                v-for="(el, i) in row['fri'].data"
                :key="i"
                :style="`background: ${el ? (el.status ? '#67C23A' : '#E6A23C') : '#909399'};`"
                :title="el ? el.orgName : '未审核'"
                v-if="i + 1 <= ((Math.log2(auditAuth) | 0) + 1) ? true : false"
                @click="onCakendarItemClick(row['fri'], i)"
              >
                {{el ? numberToCN[i + 1] + '审' : '未审核'}}
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="sat" label="六" align="center">
        <template slot-scope="{row}">
          <div>
            <h4 style="margin: 2px; text-align:center;">{{row['sat'].dataTime ? new Date(row['sat'].dataTime).format('DD') : ''}}</h4>
            <div style="display: flex;justify-content: space-around;">
              <p
                class="my-button"
                v-for="(el, i) in row['sat'].data"
                :key="i"
                :style="`background: ${el ? (el.status ? '#67C23A' : '#E6A23C') : '#909399'};`"
                :title="el ? el.orgName : '未审核'"
                v-if="i + 1 <= ((Math.log2(auditAuth) | 0) + 1) ? true : false"
                @click="onCakendarItemClick(row['sat'], i)"
              >
                {{el ? numberToCN[i + 1] + '审' : '未审核'}}
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="sun" label="日" align="center">
        <template slot-scope="{row}">
          <div>
            <h4 style="margin: 2px; text-align:center;">{{row['sun'].dataTime ? new Date(row['sun'].dataTime).format('DD') : ''}}</h4>
            <div style="display: flex;justify-content: space-around;">
              <p
                class="my-button"
                v-for="(el, i) in row['sun'].data"
                :key="i"
                :style="`background: ${el ? (el.status ? '#67C23A' : '#E6A23C') : '#909399'};`"
                :title="el ? el.orgName : '未审核'"
                v-if="i + 1 <= ((Math.log2(auditAuth) | 0) + 1) ? true : false"
                @click="onCakendarItemClick(row['sun'], i)"
              >
                {{el ? numberToCN[i + 1] + '审' : '未审核'}}
              </p>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <data-wrapper v-if="!isCalendar">
      <template #header>
        <el-radio-group v-model="radio" size="medium" style="margin-top: 5px;" @change="ratioChange">
          <el-radio-button label="gather" >捕集率</el-radio-button>
          <el-radio-button label="effective">有效率</el-radio-button>
        </el-radio-group>
      </template>

      <div class="main-inner-wrapper" >
        <el-table
          :data="tableData"
          border
          stripe
          height="100%"
          style="width: 100%"
          highlight-current-row
          header-row-class-name="custom-table-header"
          class="custom-table no-inner-border"
        >
          <el-table-column
            v-for="(item, i) in headerColumn"
            :key="i"
            :prop="item.id"
            :label="item.name"
          >
            <template slot-scope="{row}">
              {{i > 2 ? ((row[item.id] * 100).toFixed(2)+ '%') : row[item.id]}}
            </template>
          </el-table-column>
        </el-table>
        <div>
          <data-statistics-chart
            ref="data-ratio-chart"
            :data="dashboard"
          />
        </div>
      </div>
    </data-wrapper>
  </template>

  <template #footer>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseEditor from '../../BaseEditor'
import CalendarChart from '../../../components/Data/CalendarChart'
import DataStatisticsChart from '../../../components/Data/DataStatisticsChart'
import numberToCN from '../../../utils/numberToCN'

export default {
  name: 'CalendarEditor',
  extends: BaseEditor,
  components: {CalendarChart, DataStatisticsChart},
  props: {
    data: {
      required: true,
      type: Object
    },
    maxAuditStage: {
      required: true,
      type: Number
    }
  },
  data () {
    return {
      isCalendar: false,
      dateTime: '',
      currentSite: {},
      currentSiteDevice: {},
      value: Number(new Date().format('MM')),
      rowKeys: ['sun', 'mon', 'tue', 'thu', 'wed', 'fri', 'sat'],
      month: '',
      dataList: [],
      calendarData: [],
      headerColumn: [],
      ratioData: {},
      tableData: [],
      ratioTotal: {},
      radio: 'gather',
      dashboard: []
    }
  },
  computed: {
    options () {
      return [{
        label: '一月',
        value: 1
      }, {
        label: '二月',
        value: 2
      }, {
        label: '三月',
        value: 3
      }, {
        label: '四月',
        value: 4
      }, {
        label: '五月',
        value: 5
      }, {
        label: '六月',
        value: 6
      }, {
        label: '七月',
        value: 7
      }, {
        label: '八月',
        value: 8
      }, {
        label: '九月',
        value: 9
      }, {
        label: '十月',
        value: 10
      }, {
        label: '十一月',
        value: 11
      }, {
        label: '十二月',
        value: 12
      }]
    },
    numberToCN: () => numberToCN
  },
  watch: {
    data (val, oldVal) {
      if (val) {
        this.isCalendar = val.isCalendar
        this.open(val)
      }
    }
  },
  methods: {
    onCakendarItemClick (data, stage) {
      let { currentSiteDevice } = this.data
      this.$emit('onCakendarItemClick', {siteDevice: currentSiteDevice, stage: stage + 1, dataTime: data.dataTime})
    },
    onOpen (model) {
      this.dateTime = model.dateTime
      this.value = Number(new Date(model.dateTime).format('MM'))
      this.currentSite = model.currentSite
      this.currentSiteDevice = model.currentSiteDevice
    },
    open (model) {
      this.onOpen(model)

      if (model.isCalendar) {
        this.getCalendarData()
      } else {
        this.getRatio()
      }

      this.opened = true
    },
    getRatio () {
      let {currentSiteDevice, dateTime} = this
      this.changeLoadStatus(true)
      this.$api.Audit.getRatio(currentSiteDevice.id, dateTime).then(data => {
        this.ratioData = data
        this.formatRatioData(data)
        this.ratioChange(this.radio)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    formatRatioData (data) {
      let {factorMap, radio} = this
      this.headerColumn = [{
        name: '因子名称',
        id: 'factorName'
      }, {
        name: '应到数',
        id: 'should'
      }, {
        name: '实到数',
        id: 'real'
      }, {
        name: radio === 'gather' ? '捕集率' : '有效率',
        id: 'ratio'
      }]
      if (Object.keys(data).length === 0) {
        this.tableData = []
        this.dashboard = [{
          value: 0
        }]
        setTimeout(() => {
          this.$refs['data-ratio-chart'].render()
        }, 10)
        return
      }

      let factorData = []
      let total = {
        factorId: '--',
        factorName: '总计',
        should: 0,
        real: 0,
        ratio: 0
      }
      for (let key in data) {
        let temp = data[key]
        let obj = {}
        obj['should'] = temp[radio + 'Denominator']
        obj['real'] = temp[radio + 'Numerator']
        obj['ratio'] = temp[radio + 'Rate']
        total['should'] = total['should'] + temp[radio + 'Denominator']
        total['real'] = total['real'] + temp[radio + 'Numerator']
        total['ratio'] = total['ratio'] + temp[radio + 'Rate']

        factorData.push({
          factorId: key,
          factorName: factorMap[key] ? factorMap[key].name : '--',
          ...obj
        })
      }

      total.ratio = total.ratio / Object.values(data).length
      this.ratioTotal = total
      factorData.push(total)
      this.tableData = factorData
      this.dashboard = [{
        value: Number((total.ratio * 100).toFixed(2))
      }]
      setTimeout(() => {
        this.$refs['data-ratio-chart'].render()
      }, 10)
    },
    ratioChange (item) {
      this.formatRatioData(this.ratioData)
    },
    getCalendarData () {
      let {currentSiteDevice, dateTime} = this
      this.changeLoadStatus(true)
      this.$api.Audit.getCalendar(currentSiteDevice.id, this.dateTime).then(data => {
        this.formatCalendarData(data, dateTime)
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    formatCalendarData (data, dateTime) {
      let year = new Date(dateTime).format('YYYY')
      let month = new Date(dateTime).format('MM')
      // 获取当月一号周几
      let tempDate = year + '-' + month + '-01'
      let firstDayWeek = new Date(tempDate)
      let week = firstDayWeek.getDay()
      week = week === 0 ? 7 : week
      // 获取当月有几天
      let dayCount = this.mGetDate(year, month)
      // let currentStartDay = this.getDateStart(year, month - 1)
      // let currentEndDay = new Date(year, month - 1, dayCount).getDay()

      // 表格数据
      let weekData = []
      // 表格行数
      let weekTemp = []
      // 获取当月有几周 并设置table有几行数据
      // let weeks = this.getWeeks(year, month - 1)
      let weeks = this.getWeekData(year, month).length
      weekTemp.length = weeks
      for (let i = 0; i < weekTemp.length; i++) {
        weekData.push({
          sun: '',
          mon: '',
          tue: '',
          thu: '',
          wed: '',
          fri: '',
          sat: ''
        })
      }

      // 数据补全
      let keys = {
        0: 'sun',
        1: 'mon',
        2: 'tue',
        3: 'wed',
        4: 'thu',
        5: 'fri',
        6: 'sat'
      }
      let {maxAuditStage} = this
      let arr = []
      arr.length = maxAuditStage
      let dateMap = {}
      for (let i = 1; i <= dayCount; i++) {
        let date = new Date(year, month - 1, i).format('YYYY-MM-DD')
        dateMap[date] = {
          data: []
        }
        for (let i = 0; i < arr.length; i++) {
          dateMap[date].data = arr
        }
        dateMap[date].dataTime = date
      }

      data.forEach((el, i) => {
        let dateTime = new Date(el.auditTime).format('YYYY-MM-DD')
        let {auditInfos} = el
        let temp = []
        if (auditInfos.length > 0) {
          temp = auditInfos
        }

        if (temp.length < maxAuditStage) {
          let arr = []
          arr.length = maxAuditStage - temp.length

          for (let i = 0; i < arr.length; i++) {
            temp.push('')
          }
        }

        dateMap[dateTime].data = temp
      })

      // 按日期赋值
      for (let date in dateMap) {
        let weekNum = this.computedWeek(date, week)
        let dates = new Date(new Date(date).format('YYYY-MM-DD'))
        let num = dates.getDay()
        let key = keys[num]

        weekData[weekNum - 1][key] = dateMap[date]
      }

      this.dataList = weekData
    },
    // 获取当月有几天
    mGetDate (year, month) {
      var d = new Date(year, month, 0)
      return d.getDate()
    },
    // 获取本月第一天是周几
    getDateStart (year, month) {
      let d = new Date(year, month, 1)
      return d.getDay()
    },
    // 日期增加 接受两个参数， 传入的时间，传入时间增加的天数
    addDate (date, days) {
      if (days === undefined || days === '') {
        days = 1
      }
      let dates = new Date(date)
      dates.setDate(dates.getDate() + days)
      let month = dates.getMonth() + 1
      if (month < 10) { month = '0' + month }
      let day = dates.getDate()
      if (day < 10) { day = '0' + day }
      return dates.getFullYear() + '-' + month + '-' + day
    },
    getWeekData (year, month) {
      // 传入  年  月  获取当月有几周 以及日期
      // 取当前的年份
      let newYear = year
      // 取下一个月的第一天，方便计算（最后一天不固定
      let newMonth = month++
      if (newMonth < 10) {
        newMonth = '0' + newMonth
      }
      let weekDay = ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期天']
      if (newMonth > 12) {
        // 月份减
        newMonth -= 12
        // 年份增
        newYear++
      }
      // 取当年当月中的第一天-时间格式
      let firstDate = new Date(newYear, newMonth, 1)
      // 获取当月最后一天日期
      let lastData = (new Date(firstDate.getTime() - 1000 * 60 * 60 * 24)).getDate()
      // 当月第一天是周几
      let firstzhouji = new Date(newYear + '/' + newMonth + '/' + 1).getDay() === 0 ? '星期天' : weekDay[new Date(newYear + '/' + newMonth + '/' + 1).getDay() - 1]
      // 当月最后一天是周几
      let lastzhouji = new Date(newYear + '/' + newMonth + '/' + lastData).getDay() === 0 ? '星期天' : weekDay[new Date(newYear + '/' + newMonth + '/' + lastData).getDay() - 1]
      // 第一周有几天
      let firstTime = ''
      if (firstzhouji === '星期一') { firstTime = 7 }
      if (firstzhouji === '星期二') { firstTime = 6 }
      if (firstzhouji === '星期三') { firstTime = 5 }
      if (firstzhouji === '星期四') { firstTime = 4 }
      if (firstzhouji === '星期五') { firstTime = 3 }
      if (firstzhouji === '星期六') { firstTime = 2 }
      if (firstzhouji === '星期天') { firstTime = 1 }

      // 最后一周有几天
      let lastTime = ''
      if (lastzhouji === '星期一') { lastTime = 1 }
      if (lastzhouji === '星期二') { lastTime = 2 }
      if (lastzhouji === '星期三') { lastTime = 3 }
      if (lastzhouji === '星期四') { lastTime = 4 }
      if (lastzhouji === '星期五') { lastTime = 5 }
      if (lastzhouji === '星期六') { lastTime = 6 }
      if (lastzhouji === '星期天') { lastTime = 7 }

      // 前后两周  加上 剩余周数  得出总周数
      let contime = 2 + (lastData - lastTime - firstTime) / 7

      // 得出每周对应的日期
      let zhouArry = []

      for (let i = 1; i <= contime; i++) {
        let strTime = ''
        let lastTime = ''
        if (i === 1) {
          strTime = year + '-' + newMonth + '-' + '01'
          let aa = 1 + firstTime - 1
          if (aa < 10) {
            aa = '0' + aa
          }
          lastTime = year + '-' + newMonth + '-' + aa
        } else if (i === contime) {
          let bb = lastData - lastTime + 1
          if (bb < 10) {
            bb = '0' + bb
          }
          strTime = year + '-' + newMonth + '-' + bb
          lastTime = year + '-' + newMonth + '-' + (lastData < 10 ? ('0' + lastData) : lastData)
        } else {
          strTime = this.addDate(zhouArry[zhouArry.length - 1].endTime, 1)
          lastTime = this.addDate(zhouArry[zhouArry.length - 1].endTime, 7)
        }

        zhouArry.push({
          weeknum: i,
          beginTime: strTime,
          endTime: lastTime
        })
      }
      return zhouArry
    },
    // 获取当月有几周
    // getWeeks (year, month) {
    //   let d = new Date()
    //   // 该月第一天
    //   d.setFullYear(year, month, 1)
    //   var w1 = d.getDay()
    //   if (w1 === 0) {
    //     w1 = 7
    //   }
    //   // 该月天数
    //   d.setFullYear(year, month, 0)
    //   let dd = d.getDate()
    //   // 第一个周一
    //   let d1
    //   // 第一天不是星期一
    //   if (w1 !== 1) {
    //     d1 = 7 - w1 + 2
    //   } else {
    //     d1 = 1
    //   }
    //   let weekCount = Math.ceil((dd - d1 + 1) / 7)
    //   if (w1 === 1) {
    //     return weekCount
    //   } else {
    //     return weekCount + 1
    //   }
    // },
    dateChange () {
      let date = new Date()
      let year = date.getFullYear()
      this.dateTime = new Date(year, this.value, 0).format('YYYY/MM/DD')
      this.getCalendarData()
    },
    // 计算当前日期是第几周
    computedWeek (date, week) {
      let dates = new Date(date)
      let day = dates.getDate()

      return Math.ceil((day + (week - 1)) / 7)
    },
    // formatCalendarData (data, dateTime) {
    //   let year = new Date(dateTime).format('YYYY')
    //   let month = new Date(dateTime).format('MM')
    //   let day = this.mGetDate(year, month)
    //   let {maxAuditStage, currentSiteDevice} = this
    //   let arr = []
    //   arr.length = maxAuditStage
    //   let dateMap = {}
    //   for (let i = 1; i <= day; i++) {
    //     let date = new Date(year, month - 1, i).format('YYYY-MM-DD')
    //     dateMap[date] = {
    //       data: [date]
    //     }
    //     for (let i = 0; i < arr.length; i++) {
    //       dateMap[date].data.push(['--', '--'])
    //     }
    //     dateMap[date].dataTime = date
    //   }
    //   data.forEach((el, i) => {
    //     let dateTime = new Date(el.auditTime).format('YYYY-MM-DD')
    //     let {auditInfos} = el
    //     let temp = []
    //     if (auditInfos.length > 0) {
    //       temp = [
    //         dateTime
    //       ].concat(auditInfos.map((el, i) => [el.status, currentSiteDevice.auditInfos[i].orgName]))
    //     }

    //     if (temp.length - 1 < maxAuditStage) {
    //       let arr = []
    //       arr.length = maxAuditStage - (dateMap[dateTime].data.length - 2)

    //       for (let i = 0; i < arr.length; i++) {
    //         temp.push(['--', '--'])
    //       }
    //     }

    //     dateMap[dateTime].data = temp
    //   })

    //   this.month = year + '-' + month
    //   this.calendarData = Object.values(dateMap)
    //   setTimeout(() => {
    //     this.$refs['calendar-chart'].render()
    //   }, 10)
    // },
    onCloseBtnClick () {
      this.opened = false
    }
  }
}
</script>

<style lang="scss" scoped>
.calendar-chart-inner {
  width: 100%;
  height: 100%;
  padding: 5px;
}
.my-button {
  width: 48px;
  overflow: hidden;
  font-size: 12px;
  padding: 3px 0px;
  margin: 2px;
  white-space: nowrap;
  text-overflow: ellipsis;
  background: #FFF;
  color: #FFF;
  border-radius: 5px;
  text-align: center;
  cursor: pointer;
}
.main-inner-wrapper {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: 55% 45%;
  grid-column-gap: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/CalendarEditor.vue